// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"back-link_wrapper__T8X0G","link":"back-link_link__y7fnv"};